/**
 * @description
 * enum for the action bottom sheet state
 * @enum BackToTopStateType
 * @property {string} DEFAULT
 * @property {string} HOVER
 * @property {string} PRESSED
 */
export var BackToTopStateType;
(function (BackToTopStateType) {
    BackToTopStateType["DEFAULT"] = "DEFAULT";
    BackToTopStateType["HOVER"] = "HOVER";
    BackToTopStateType["PRESSED"] = "PRESSED";
})(BackToTopStateType || (BackToTopStateType = {}));
//# sourceMappingURL=state.js.map